import type { QueryTicketDto, QueryUser } from '@restore/queries/queries.types';

const UNKNOWN_PARTICIPANT_NAME = 'Unknown user';
const UNKNOWN_PARTICIPANT_INITIALS = '?';

export const findQueryParticipant = (
  query: Pick<QueryTicketDto, 'author' | 'recipients'>,
  userId: string
): QueryUser | undefined =>
  [query.author, ...(query.recipients ?? [])].find(user => user?.id === userId);

export const formatParticipantName = (user?: QueryUser): string =>
  `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim() ||
  UNKNOWN_PARTICIPANT_NAME;

export const formatParticipantInitials = (user?: QueryUser): string => {
  const firstInitial = user?.firstName?.[0] ?? '';
  const lastInitial = user?.lastName?.[0] ?? '';

  return (
    `${firstInitial}${lastInitial}`.toUpperCase() ||
    UNKNOWN_PARTICIPANT_INITIALS
  );
};
